import { FunctionComponent } from 'react';
import Chip from '@mui/material/Chip';
import { IStatusChipProps } from './StatusChip.interface';

export const StatusChip: FunctionComponent<IStatusChipProps> = ({ label, color = 'default', variant, sx }) => {
  return (
    <Chip
      label={label}
      color={color}
      variant={variant}
      size={'small'}
      sx={sx}
    />
  );
};
